module.exports = __webpack_public_path__ + "static/media/details-27-image-3.cde64951.jpg";